import React, { useState } from 'react';
import styled from 'styled-components';
import { Radio } from 'tdesign-react';
import Producer from './Producer';
import Consumer from './Consumer';

export default function Client() {
  const [value, setValue] = useState('producer');
  return (
    <Root>
      <Radio.Group variant='default-filled' value={value} onChange={setValue}>
        <Radio.Button value='producer'>生产者</Radio.Button>
        <Radio.Button value='consumer'>消费者</Radio.Button>
      </Radio.Group>
      {value === 'producer' && <Producer />}
      {value === 'consumer' && <Consumer />}
    </Root>
  );
}

const Root = styled.div`
  padding-top: 20px;
  .t-radio-button.t-is-checked {
    background-color: var(--td-brand-color-7);
    border-radius: 6px;
    .t-radio-button__label {
      color: #fff;
      font-weight: bold;
    }
  }
  .t-radio-group__bg-block {
    background-color: rgba(0, 0, 0, 0.1) !important;
    border-radius: 6px !important;
  }
`;
